<template>
    <div class="search-box">
        <el-row>
            <el-form ref="form" :model="formList" label-width='auto'>
                <el-col :span="6" v-for="(item, index) in list" :key="index">
                    <el-form-item :label="item.label">
                        <el-input :placeholder="item.placeholder" v-model="formList[item.type]"></el-input>
                    </el-form-item>
                </el-col>
                <slot name="search-box-btn"></slot>
            </el-form>
        </el-row>


    </div>
</template>
  
<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        },
        form: {
            type: Object,
            default: () => { }
        }
    },
    data () {
        return {


        }
    },
    components: {
    },
    computed: {
        formList () {
            return this.$props.form
        }
    },
    methods: {
    },
    mounted () {

    }

}
</script>
  
<style lang="scss" scoped>
.search-box {
    width: 100%;
    height: 100%;

    .el-form {
        /deep/ .el-form-item {
            display: flex;
            display: inline-block;
            margin-right: 2%;
        }
    }
}
</style>